import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';
import { setSnackBar } from '../../states/app/staticSlice';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function usePaymentStatus(userId) {
  const dispatch = useDispatch();
  const { data, error, isLoading, isValidating, mutate } = useSWR(
    userId ? '/paymentstatuses/' : null,
    (url) => fetcher(url),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  useEffect(() => {
    if (error?.response && error?.response?.status > 300) {
      const messageError = `Error: ${error?.response?.status} - ${error?.response?.statusText}: OrderStatus`;
      dispatch(
        setSnackBar({ open: true, message: messageError, color: 'error' })
      );
    } else {
      dispatch(setSnackBar({ open: false, message: null, color: null }));
    }
  }, [error, data, dispatch]); // Ajoutez les dépendances pertinentes

  return {
    data: data,
    res: {
      status: data?.code || error?.response?.status,
      statusText: data?.message || error?.response?.statusText,
    },
    isLoading: isLoading,
    isValidating: isValidating,
    mutate: mutate,
  };
}

export default usePaymentStatus;
